import { Bundle } from '@ali/visualengine';
import style from '@ali/vu-style-property';
import { componentNameForUrlPage } from "../../const";
import Icon from "./logo";
export default Bundle.createPrototype({
  enableCopy: true,
  title: '嵌入页面',
  componentName: componentNameForUrlPage,
  category: '高级',
  icon: Icon,
  screenshot: '',
  docUrl: '',
  configure: [{
    name: 'url',
    title: '页面 url',
    display: 'block',
    setter: 'StringSetter',
    supportVariable: true
  }, {
    name: 'fullHeight',
    title: '撑满父容器高度',
    tip: '如果想撑满整个页面, 请先确保父容器撑满页面',
    display: 'block',
    setter: 'BoolSetter',
    initialValue: false
  }, style({
    advanced: true
  })]
});